export const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
